import React from "react";

export const VuesaxBulkSms = ({ className }) => {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5Z"
        fill="url(#paint0_linear_12_4800)"
        opacity="0.4"
      />

      <path
        d="M12.0008 12.87C11.1608 12.87 10.3108 12.61 9.66076 12.08L6.53075 9.58C6.21075 9.32 6.15076 8.85 6.41076 8.53C6.67076 8.21 7.14076 8.15 7.46076 8.41L10.5908 10.91C11.3508 11.52 12.6407 11.52 13.4007 10.91L16.5308 8.41C16.8508 8.15 17.3308 8.2 17.5808 8.53C17.8408 8.85 17.7908 9.33 17.4608 9.58L14.3308 12.08C13.6908 12.61 12.8408 12.87 12.0008 12.87Z"
        fill="url(#paint1_linear_12_4800)"
      />

      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_12_4800"
          x1="2"
          x2="22"
          y1="12"
          y2="12"
        >
          <stop stopColor="#FF6EB3" />

          <stop offset="0.471154" stopColor="#AA81FF" />

          <stop offset="1" stopColor="#6BC9FF" />
        </linearGradient>

        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear_12_4800"
          x1="6.24805"
          x2="17.7466"
          y1="10.5571"
          y2="10.5571"
        >
          <stop stopColor="#FF6EB3" />

          <stop offset="0.471154" stopColor="#AA81FF" />

          <stop offset="1" stopColor="#6BC9FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
